import * as ACTIONS from '../actions/actionTypes';

const initialState = {
  data: {}
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.AUTH_UPDATE:
      return {
        ...state,
        data: action.data
      };
    default:
      return state;
  }
}